import useGenericRiskActions from './useGenericRiskActions';
import queryContentRisk from './queryContentRisks';

export default function() {
    const fetchFn = (subject) => queryContentRisk({ subject });

    return useGenericRiskActions(fetchFn);
}
